export enum OpenCaseTypeEnum {
  Lead = 'LEAD',
  Active = 'ACTIVE',
}
